import React, { PropsWithChildren } from 'react';

import { ThemeProvider as MuiV5ThemeProvider } from '@mui/material/styles';

import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';

import { registerLocale } from 'react-datepicker';
import esLocale from 'date-fns/locale/es';

import 'react-datepicker/dist/react-datepicker.css';
import 'components/Reports/Fees/Calendar/style.css';

import ErrorBoundary from 'components/shared/ErrorBoundary';

import { getFullscreenTable, getThemeMode } from 'store/globalApp';

import useThemeV5 from 'themeV5/useTheme';

import { modelPortfolioRootStyles } from './styles';

registerLocale('es', esLocale);

const MuiAppTheme = ({ children }: PropsWithChildren) => {
  const themeMode = useSelector(getThemeMode);

  const [mode, setMode] = React.useState<'light' | 'dark'>(themeMode);

  const fullscreenTable = useSelector(getFullscreenTable);

  const themeV5 = useThemeV5(mode);

  React.useEffect(() => setMode(themeMode), [themeMode]);

  return (
    <MuiV5ThemeProvider theme={themeV5}>
      <Box sx={fullscreenTable ? modelPortfolioRootStyles : {}}>
        <CssBaseline />
        <ErrorBoundary mode={mode}>{children}</ErrorBoundary>
      </Box>
    </MuiV5ThemeProvider>
  );
};

export default MuiAppTheme;
